
























































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import FaqBox from '@/components/FaqBox.vue';
import '../../public/static/assets/css/lp_metopo.css';
@Component({
  components: { FaqBox }
})
export default class P0924 extends Vue {}
